module.exports = {
          srcSet: __webpack_public_path__ + "images/2019-2-7230efb7da19c892fe7a0cc10ce6b043-320.jpg"+" 320w"+","+__webpack_public_path__ + "images/2019-2-de7e6959deeec18881f382db07a383d4-370.jpg"+" 370w",
          images:[ {path: __webpack_public_path__ + "images/2019-2-7230efb7da19c892fe7a0cc10ce6b043-320.jpg",width: 320,height: 251},{path: __webpack_public_path__ + "images/2019-2-de7e6959deeec18881f382db07a383d4-370.jpg",width: 370,height: 290}],
          src: __webpack_public_path__ + "images/2019-2-7230efb7da19c892fe7a0cc10ce6b043-320.jpg",
          toString:function(){return __webpack_public_path__ + "images/2019-2-7230efb7da19c892fe7a0cc10ce6b043-320.jpg"},
          
          width: 320,
          height: 251
        }